var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6457 15.1115C20.8236 15.9752 19.6915 16.5494 18.409 16.6481C15.6557 16.86 13.252 14.7998 13.0401 12.0465C12.9849 11.3298 13.0837 10.6368 13.3086 10C11.2037 11.0082 9.82763 13.2341 10.0174 15.7009C10.2642 18.9077 13.0639 21.3072 16.2706 21.0605C19.3755 20.8215 21.7237 18.1893 21.6457 15.1115Z",
    fill: "url(#paint0_linear_10214_685)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_685",
    x1: 13.3599,
    y1: 12.4233,
    x2: 22.1984,
    y2: 15.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01N);
export default __webpack_public_path__ + "static/media/01n.061f305a232391b26a8e9c2462afd290.svg";
export { ForwardRef as ReactComponent };